import { getGlobal } from "../lib/get-global";
import { getUrlSearchParams } from "../lib/query-string";
import { MetadataPlugin } from "./metadata";

export const createReferrerCodePlugin: MetadataPlugin<string> = function () {
  const globalThis = getGlobal();

  if (
    typeof globalThis === "undefined" ||
    typeof localStorage === "undefined"
  ) {
    return {
      getValue() {
        return {};
      },
    };
  }

  const REFERRER_CODE_KEY = "spindl_referrer_code";

  let referrerCode = localStorage.getItem(REFERRER_CODE_KEY) || "";

  async function getValue() {
    const urlParams = getUrlSearchParams();
    const newReferrerCode = urlParams.get("ref");

    if (newReferrerCode && newReferrerCode !== referrerCode) {
      referrerCode = newReferrerCode;
      localStorage.setItem(REFERRER_CODE_KEY, referrerCode);
    }

    if (!referrerCode) {
      return {};
    }

    return { referrerCode };
  }

  return {
    getValue,
  };
};
